// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapLink } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { NewsBar } from '../_components/ui';
/**
 * Component capable of rendering the `NewsBarModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let InfoBarModuleUi = class InfoBarModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * Items to render.
         */
        this.items = [];
        this.close = true;
    }
    mounted() {
        const todayDate = this.getTodayDate();
        const closedDate = localStorage.getItem('InfoBarModuleUi_closed_date');
        if (closedDate !== todayDate) {
            this.close = false;
        }
    }
    getTodayDate() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = (today.getMonth() + 1).toString().padStart(2, '0');
        const dd = today.getDate().toString().padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }
    /**
     * @inheritDoc
     */
    fetchRelatedSync() {
        const itemsToResolve = this.module.content.items || [];
        itemsToResolve.map(item => {
            if (item.related === null) {
                this.items = [
                    ...this.items, {
                        ...item,
                        contentSneakPeak: null
                    }
                ];
                return;
            }
            const article = this.relatedService.resolveSync(item.related, {});
            if (article) {
                this.items = [
                    ...this.items, {
                        ...item,
                        contentSneakPeak: article
                    }
                ];
            }
        });
        this.items.length > 0 ? this.onReady() : this.onError();
    }
    onClose() {
        this.close = true;
        const todayDate = this.getTodayDate();
        localStorage.setItem('InfoBarModuleUi_closed_date', todayDate);
    }
};
InfoBarModuleUi = __decorate([
    Component({
        name: 'InfoBarModuleUi',
        components: {
            BootstrapLink,
            NewsBar
        },
        created() {
            this.fetchRelatedSync();
        },
        template: `
    <section class="info-bar-module module" :class="[]" :style="{backgroundColor: customColor}">
    <NewsBar v-if="!close" :color="module.content.backgroundColor" @close="onClose" closable>
      <ul class="info-bar-module__list list-inline">
        <li v-for="item in items" :key="item.label"
            class="info-bar-module__list__item list-inline-item">
          <BootstrapLink v-if="!!item.contentSneakPeak" :link="{ target: item.contentSneakPeak.urlPath }">
            {{ item.label }}
          </BootstrapLink>
          <BootstrapLink v-else :link="{ target: item.externalUrl, isExternal: true }">
            {{ item.label }}
          </BootstrapLink>
        </li>
      </ul>
    </NewsBar>
    </section>
  `
    })
], InfoBarModuleUi);
export { InfoBarModuleUi };
